module.exports = __webpack_public_path__ + "static/media/icons.b0d65d14.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icons.woff
// module id = 290
// module chunks = 0